import { render, staticRenderFns } from "./DuelsStats.vue?vue&type=template&id=cca0fc6c&scoped=true"
import script from "./DuelsStats.vue?vue&type=script&lang=js"
export * from "./DuelsStats.vue?vue&type=script&lang=js"
import style0 from "./DuelsStats.vue?vue&type=style&index=0&id=cca0fc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca0fc6c",
  null
  
)

export default component.exports